module.exports = __webpack_public_path__ + "static/books-for-living-b3bfa4df974c9598f574dedebcf95a9c.jpg";